export interface BrowserStorage {
  getItem: (key: string) => null | string;
  setItem: (key: string, value: string) => void;
  removeItem: (key: string) => void;
  clear(): void;
  clearExcept(preservedKeys: readonly string[]): void;
}

export const browserStorage: BrowserStorage = {
  clear: () => window.localStorage.clear(),
  /** Wipe app state while leaving `preservedKeys` in place — used on sign-out,
   * where browser-level preferences (theme mode, accent) must outlive the
   * session. Removes by key rather than clear-and-restore so a write failure
   * can't drop the preserved values. */
  clearExcept: (preservedKeys: readonly string[]) => {
    const keep = new Set(preservedKeys);
    const doomed = Object.keys(window.localStorage).filter(
      (key) => !keep.has(key)
    );
    doomed.forEach((key) => window.localStorage.removeItem(key));
  },
  getItem: (key: string) => window.localStorage.getItem(key),
  removeItem: (key: string) => window.localStorage.removeItem(key),
  setItem: (key: string, value: string) =>
    window.localStorage.setItem(key, value)
};
